<template>
  <div class="page-outbox">
  	<!--搜索框-->
  	<div class="search-group-wapper">
  		<search-block @searchSub='searchSub' ref="searchBlock"></search-block>
  	</div>
  	<!--操作栏-->
  	<div class="opration-tip-bar">
  		<p class="shop-bag-tip">您的购物车有{{$store.state.shopCount}}款产品</p>
  		<div class="opration-btns" v-if="data.length">
  			<button @click="deleteItems">删除</button>
  			<button @click="deleteAll">清空</button>
  		</div>
  	</div>
  	<!--列表-->
    <div class="list-wapper">
    	<scroll @scroll="scroll"
	            @scrollToEnd="scrollToEnd"
	            @scrollToTop="scrollToTop"
	            :listen-scroll="listenScroll"
	            :probe-type="probeType"
	            :data="data"
	            :pullup="true"
	            class="listview"
	            ref="listview">
	      <ul class="query-list">
	        <div class="pullDown">{{pullDownMsg}}</div>
          <p class="empty-list" v-if="data.length<1">暂无数据</p>
	        <li class="list-item" v-for="(item,index) in data" ref="listGroup" @click="toDetail(item)">
	        	<order-item :goodsData="item" :index="index" :selecteable="true" @selectItem="selectItem" @changeItemNum="changeItemNum"></order-item>
	        </li>
	        <div class="pullUp">{{pullUpMsg}}</div>
	      </ul>
	    </scroll>
    </div>

  	<!--提交栏-->
  	<div class="submit-bar" v-if="data.length">
  		<p class="check-box all"><check-item @clickItem="selectAllClick" :itemChecked="selectAll"></check-item><span @click="selectAllClick">全选</span></p>
  		<p class="total-price">总价:<span>￥{{totalPrice}}</span></p>
  		<button class="submit-btn" id="toPay" @click="toPay">去结算(不含运费)</button>
  	</div>
  </div>
</template>

<script>
  import Scroll from 'basic/scroll/scroll'
  import OrderItem from 'basic/orderItem/orderItem'
  import CheckItem from 'basic/checkItem/checkItem'
	import SearchBlock from 'basic/searchBlock/searchBlock'
	export default {
		name: 'shopBag',
    data () {
      return {
	  	keyWord:'',
	  	curPage: 0,
	    data: [],
	    pullDownMsg: "下拉刷新",
	    pullUpMsg: "上拉加载",
	    maxY: 0,
	    hasMore:false,
	    listenScroll:true,
	    probeType:3
      }
    },
    computed:{
    	totalPrice(){
    		var _totalPrice=0;
    		for(var i=0;i<this.selectedGoods.length;i++){
      		_totalPrice+=this.selectedGoods[i].price*this.selectedGoods[i].num;
      	}
    		return _totalPrice;
    	},
    	selectAll(){
    		var  isAll=true;
      	for(var i=0;i<this.data.length;i++){
      		if(this.data[i].if_checked=="0"){
      			isAll=false;
      			break;
      		}
      	}
      	return isAll;
    	},
    	selectedGoods(){
    		var selectedArr=[];
  			for(var i=0;i<this.data.length;i++){
      		if(this.data[i].if_checked=="1"){
      			selectedArr.push(this.data[i]);
      		}
      	}
  			return selectedArr;
    	}
    },
    mounted(){
			if(this.$route.meta&&this.$route.meta.pageBelong){
				this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
			}
			this.keyWord=this.$route.params.keyword;
			this.$refs.searchBlock.setKeyword(this.$route.params.keyword);
			this.probeType = 3;
      this.listenScroll = true;
      this.touch = {};

      this._getData(true);
    },
    methods:{
    	searchSub(keyWord){
    		this.$router.push({path:'/GoodsList/'+keyWord})
    	},

    	toPay(){
    		if(!this.totalPrice){
    			this.$messagebox.alert('温馨提示','请选择需要结算的商品');
    			return;
    		}
    		//清除之前存储的发票地址等信息
        this.$store.commit('setSelectedAddrData',{})
        this.$store.commit('setSelectedInvoiceAddrData',{})
        this.$store.commit('setSelectedInvoiceData',{})
    		this.$router.push({path:'/SubmitOrder'})
    	},
    	refresh() {
        this.$refs.listview.refresh()
      },
      scroll(scrollPos,maxY) {
        if (scrollPos.y > 30) {
          this.pullDownMsg='释放刷新';
        }
        if(this.hasMore){
          if(scrollPos.y<= (maxY - 40)&&this.hasMore){
            this.pullUpMsg='释放加载更多';
          }
        }else{
          this.pullUpMsg='';
        }

      },
      scrollToEnd(){
      	if(this.hasMore){
      		this._getData();
      	}

      },
      scrollToTop(){
      	//this.hasMore=true;
      	this.curPage=0;
        this._getData(true);
      },
      toDetail(item){
        	//this.$router.push({path:'/GoodsDetail/'+item.id})
      },
      selectItem(index){
    	  //修改选中状态
        var that=this;
        that.$cHttp.post('shopcart/update',{
          partner:that.$systemConfig.partner,
          apikey:that.$systemConfig.apikey,
          user_id:that.$store.state.userInfo.user_id,
          id:that.data[index].id,
          if_checked:that.data[index].if_checked=="1"?"0":"1",
          num:that.data[index].num
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            //修改购物车数量
            that.$store.commit('setShopCount',res.data.total_num);
            that.data=res.data.items;
          }else{

          }
        }).catch((msg)=>{
          that.$toast(msg);
        })
      },
      selectAllClick(){

        //全选
        var that=this;
        that.$cHttp.post('shopcart/checkall',{
          partner:that.$systemConfig.partner,
          apikey:that.$systemConfig.apikey,
          user_id:that.$store.state.userInfo.user_id,
          if_checked:this.selectAll?"0":"1"
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            //修改购物车数量
            that.$store.commit('setShopCount',res.data.total_num);
            that.data=res.data.items;
          }else{

          }
        }).catch((msg)=>{
          that.$toast(msg);
        })
      },
      changeItemNum(index,num){
    	  //修改数量
        var that=this;
        that.$cHttp.post('shopcart/update',{
          partner:that.$systemConfig.partner,
          apikey:that.$systemConfig.apikey,
          user_id:that.$store.state.userInfo.user_id,
          id:that.data[index].id,
          if_checked:that.data[index].if_checked,
          num:num
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            //修改购物车数量
            that.$store.commit('setShopCount',res.data.total_num);
            that.data=res.data.items;
          }else{

          }
        }).catch((msg)=>{
          that.$toast(msg);
        })
      },
      deleteItems(){
      	var that=this;
  			if(!this.selectedGoods.length){
  				this.$messagebox.alert('请选择要删除的商品','温馨提示');
  				return;
  			}
  			if(this.selectedGoods.length>1){
  				this.$messagebox.alert('只能单个删除','温馨提示');
  				return;
  			}
      	this.$messagebox.confirm('确定删除选中商品？','温馨提示',{callback:function(type){
      		if(type=='confirm'){
      			//删除选中数据 然后刷新列表
            that.$cHttp.post('shopcart/delete',{
              partner:that.$systemConfig.partner,
              apikey:that.$systemConfig.apikey,
              user_id:that.$store.state.userInfo.user_id,
              id:that.selectedGoods[0].id
            }).then((res)=>{
              console.log(res)
              if(res.status&&res.status==1){
                that.$toast("删除成功！");
                //修改购物车数量
                that.$store.commit('setShopCount',res.data.total_num);
                that.data=res.data.items;
              }else{
                that.$toast('暂无数据')
              }
            }).catch((msg)=>{
              that.$toast(msg);
            })
      		}
      	}});
      },
      deleteAll(){
    	  var that=this;
      	this.$messagebox.confirm('确定删除所有商品？','温馨提示',{callback:function(type){
      		console.log(type)
      		if(type=='confirm'){
      			//删除选中数据 然后刷新列表
            that.$cHttp.post('shopcart/clear',{
              partner:that.$systemConfig.partner,
              apikey:that.$systemConfig.apikey,
              user_id:that.$store.state.userInfo.user_id
            }).then((res)=>{
              console.log(res)
              if(res.status&&res.status==1){
                that.$toast("删除成功！");
                //修改购物车数量
                that.$store.commit('setShopCount',res.data.total_num);
                that.data=res.data.items;
              }else{
                that.$toast('暂无数据')
              }
            }).catch((msg)=>{
              that.$toast(msg);
            })
      		}
      	}});
      },
      _getData(clear){
        if(!this.$store.state.userInfo.user_id){
          //先登录
          this.$router.push('/Login?backRoute='+this.$route.path);
          return;
        }
        this.$cHttp.post('shopcart/index',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id
        }).then((res)=>{
          if(res.status&&res.status==1){
            console.log(res)
            this.data=res.data.items;
            //修改购物车数量
            this.$store.commit('setShopCount',res.data.total_num);
          }else{
            this.$toast(res.error_msg)
          }

        }).catch((msg)=>{
          this.$toast(msg);
        })

      	/*if(clear){
      		this.data=tempListData;
      	}else{
      		this.data=this.data.concat(tempListData);
      	}
      	//假设总共只有3页
      	if(this.curPage==3){
      		this.hasMore=false;
      		this.pullUpMsg='没有更多数据了';
      	}
      	this.curPage++;*/
      }
    },
    components:{
        SearchBlock,Scroll,OrderItem,CheckItem
    }
	}
</script>

<style>
	.mint-cell{
		min-height: auto;
	}
	.mint-field-core{
		text-align: center;
	}
	.mint-cell-wrapper{
		padding: 0 .05rem;
	}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
	.search-group-wapper{
		position: absolute;
		top:0;
    left:0;
    width: 100%;
	}
	.opration-tip-bar{
	  position: absolute;
	  width: 100%;
	  top:.61rem;;
		left:0;
		display: flex;
		padding: 0 .1rem;
		line-height: .25rem;
		font-size: .14rem;
		background-color: #eee;
		box-sizing: border-box;
		.shop-bag-tip{
			flex:1;
		}
		.opration-btns{
			>button{
				font:inherit;
				color: #FFA000;
				border:none;
				background:transparent;
				&:active{
					color: #ff8000;
					background-color: #ddd;
				}
			}
		}
	}
	.listview{
	  position: absolute;
	  width: 100%;
	  top:.86rem;;
		left:0;
		bottom:.45rem;
	  overflow: hidden;
	}
	.list-wapper{
	  .query-list{
	    min-height: 100.3%;
	    .pullDown{
	      position: absolute;
	      top: -32px;
	      left: 0;
	      padding: 10px 0;
	      width: 100%;
	      text-align: center;
	      font-size: 12px;
	      color: #999;
	    }
	    .pullUp{
	      position: absolute;
	      bottom: -32px;
	      left: 0;
	      padding: 10px 0;
	      width: 100%;
	      text-align: center;
	      font-size: 12px;
	      color: #999;
	    }
	    .list-item{
		     border-bottom: 1px solid #eee;

	    }
	  }
	}
	.submit-bar{
		display: flex;
		position:fixed;
		bottom: .45rem;
		left:0;
		right:0;
		padding-left: .1rem;
		font-size: .14rem;
		line-height: .45rem;
		border-top: 1px solid #ccc;
		background-color: #fff;
		.check-box.all{
			padding-right: .1rem;
			display: flex;
			align-items: center;
		}
		.total-price{
			flex:1;
			>span{
				padding: 0 .08rem;
				color: $mainColor;
			}
		}
		.submit-btn{
			padding: 0 .05rem;
			font-size: .14rem;
			color: #fff;
			border:none;
			background-color: #ffb820;
			&:active{
				background-color: #FFA000;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/components/shopBag/shopBag.vue